import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const inquiryApi = createApi({
    reducerPath: 'inquiryApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),

    endpoints: builder => ({

        getAllInquires: builder.query({
            query: () => `/list_contacts/`,
        }),

    }),
});

export const {
    useGetAllInquiresQuery,
 } = inquiryApi;
